<template>
  <section class="toolchoose" id="toolchoose-section">
    <div class="content">
      <div class="toolchoose-row">
        <div>
          <h1 :class="{ 'font-weight-bold': lang === 'ru' }" class="title" v-text="translations[lang].title" />

          <div class="toolchoose--subtitle" v-html="translations[lang].subtitle" />

          <div v-for="(item, index) in translations[lang].items" :key="index" class="toolchoose-item">
            <img :src="require(`@/assets/img/${item.icon}`)" class="toolchoose--ico" alt="icon" />
            <span v-html="item.description" />
          </div>
        </div>

        <div>
          <img class="toolchoose--circles" :src="require(`@/assets/img/toolchoose-circles-${lang}.svg`)" alt="icon" />
        </div>
      </div>

      <button v-if="lang === 'ru'" @click="scrollToShowcase" class="custom-button" v-text="translations[lang].button" />
      <router-link v-if="lang === 'en'" :to="{ path: '/pricing', hash: '#pricing-and-catalog-section' }" class="custom-button introductionItem__button btn-service-upload-2">Upload a floor plan</router-link>
      <!-- <a @click="trackButtonClick" class="custom-button" v-if="lang === 'en'">
        <input @click="trackButtonClick" @change="(e) => open('toolchoose', e.target.files)" multiple accept="image/*,application/pdf" type="file" name="uploaded-plan" id="upload-plan-input" title="" />
        Upload a floor plan
      </a> -->
    </div>
  </section>
</template>

<script>
import { smoothScroll } from '@/helpers';
import config from '@/config';
import { triggeringYandexMetric } from '@/assets/js/yandex-metrics';

export default {
  name: 'ToolChoose',
  props: {
    open: {
      default: () => null,
      type: Function,
    },
    lang: {
      type: String,
      default: 'en',
    },
  },
  data: () => ({
    translations: {
      en: {
        button: 'Upload a floor plan',
        items: [
          {
            icon: 'icons/toolchoose-ico-1.svg',
            description: 'A full bundle of visuals for real<br> estate for <span class="toolchoose--orange">$45</span>',
          },
          {
            icon: 'icons/toolchoose-ico-2.svg',
            description: 'Ready-made visuals<br> in <span class="toolchoose--orange">24</span> hours',
          },
          {
            icon: 'icons/toolchoose-ico-3.svg',
            description: 'Realistic, attractive visuals <span class="toolchoose--orange">2D</span>,<br> <span class="toolchoose--orange">3D</span> floor plans & <span class="toolchoose--orange">360</span> tour',
          },
          {
            icon: 'icons/toolchoose-ico-4.svg',
            description: '<span class="toolchoose--orange">Easy to use</span>, no human<br> involvement',
          },
        ],
        subtitle: 'Use <span class="toolchoose--orange">AI Getfloorplan</span> to create visuals',
        title: 'AI creates 2D, 3D and virtual tour',
      },
      ru: {
        button: 'Попробовать',
        items: [
          {
            icon: 'icons/save_rub.svg',
            description: 'Полный пакет материалов <br/>для недвижимости от <span class="toolchoose--orange">2 450 ₽</span>',
          },
          {
            icon: 'icons/toolchoose-ico-1.svg',
            description: 'Готовые материалы <br/><span class="toolchoose--orange">за 24 часа</span>',
          },
          {
            icon: 'icons/toolchoose-ico-3.svg',
            description: '<span class="toolchoose--orange">Реалистичные и привлекательные</span> <br/>визуализации',
          },
          {
            icon: 'icons/toolchoose-ico-4.svg',
            description: '<span class="toolchoose--orange">Легко получить</span> без личного<br/> участия',
          },
        ],
        subtitle: 'Используйте <span class="toolchoose--orange">ИИ Hart Estate</span> для создания маркетинговых материалов',
        title: '3D, туры 360 и рендеры от ИИ',
      },
    },
  }),
  methods: {
    scrollToShowcase() {
      smoothScroll('showcase');
    },

    trackButtonClick() {
      if (config.appEnv === 'production') {
        try {
          triggeringYandexMetric.submitOldUploadFormToolChoose();
        } catch (error) {
          console.error(error);
        }
      }
    },
  },
};
</script>
